import React, { useState, useEffect } from 'react';
import MarginBottom from './MarginBottom';
import { useSelector } from 'react-redux';
import { ethers } from 'ethers';
import YourHistory from './FRHistoryAll/YourHistory';
import FRTable from './FRTable/FRTable';

const styles = {
  active: 'transition ease-in-out  bg-black/50 hover:-translate-y-1 hover:scale-110 duration-100 px-5 py-3 text-sm rounded-xl shadow-md shadow-gray-500 ',
  inactive: 'transition ease-in-out  bg-black/50 hover:-translate-y-1 hover:scale-110 duration-100 px-5 py-3 text-sm rounded-xl',

}

const FRHistory = () => {
  const [toggle, setToggle] = useState(true);
  const { connect, lotteryContract, tuesdayContract } = useSelector(
    state => state.provider
  );
  const { both, tuesday, friday, tuesdayTime, fridayTime } = useSelector(state => state.lotteryDay);
  

  const [poolPrize, setPoolPrize] = useState(0);
  const [totalPlayer, setTotalPlayer] = useState(0);
  const [drawnTime, setDrawnTime] = useState(0);
  const [currentRoundNumber, setCurrentRoundNumber] = useState(0);
  const [roundNumber, setRoundNumber] = useState(0);
  const [winningNumber1, setWinningNumber1] = useState(0);
  const [winningNumber2, setWinningNumber2] = useState(0);
  const [winningNumber3, setWinningNumber3] = useState(0);
  const [winningNumber4, setWinningNumber4] = useState(0);
  const [winningNumber5, setWinningNumber5] = useState(0);
  const [winningNumber6, setWinningNumber6] = useState(0);
  const [winningNumber7, setWinningNumber7] = useState(0);

  const [totalPoolPrize1, setTotalPoolPrize1] = useState(0);
  const [totalPoolPrize2, setTotalPoolPrize2] = useState(0);
  const [totalPoolPrize3, setTotalPoolPrize3] = useState(0);
  const [totalPoolPrize4, setTotalPoolPrize4] = useState(0);
  const [totalPoolPrize5, setTotalPoolPrize5] = useState(0);
  const [totalPoolPrize6, setTotalPoolPrize6] = useState(0);
  const [maintenanceAmount, setMaintenanceAmount] = useState(0);

  const [perPersonPrize1, setPerPersonPrize1] = useState(0);
  const [perPersonPrize2, setPerPersonPrize2] = useState(0);
  const [perPersonPrize3, setPerPersonPrize3] = useState(0);
  const [perPersonPrize4, setPerPersonPrize4] = useState(0);
  const [perPersonPrize5, setPerPersonPrize5] = useState(0);
  const [perPersonPrize6, setPerPersonPrize6] = useState(0);

  const [totalPersonPrize1, setTotalPersonPrize1] = useState(0);
  const [totalPersonPrize2, setTotalPersonPrize2] = useState(0);
  const [totalPersonPrize3, setTotalPersonPrize3] = useState(0);
  const [totalPersonPrize4, setTotalPersonPrize4] = useState(0);
  const [totalPersonPrize5, setTotalPersonPrize5] = useState(0);
  const [totalPersonPrize6, setTotalPersonPrize6] = useState(0);

  useEffect(
    () => {
      if (connect) {
        getRoundNumber();

        setPoolPrize(0);
        setTotalPlayer(0);
        setDrawnTime(0);
        setWinningNumber1(0);
        setWinningNumber2(0);
        setWinningNumber3(0);
        setWinningNumber4(0);
        setWinningNumber5(0);
        setWinningNumber6(0);
        setWinningNumber7(0);

        setTotalPoolPrize1(0);
        setTotalPoolPrize2(0);
        setTotalPoolPrize3(0);
        setTotalPoolPrize4(0);
        setTotalPoolPrize5(0);
        setTotalPoolPrize6(0);
        setMaintenanceAmount(0);

        setPerPersonPrize1(0);
        setPerPersonPrize2(0);
        setPerPersonPrize3(0);
        setPerPersonPrize4(0);
        setPerPersonPrize5(0);
        setPerPersonPrize6(0);

        setTotalPersonPrize1(0);
        setTotalPersonPrize2(0);
        setTotalPersonPrize3(0);
        setTotalPersonPrize4(0);
        setTotalPersonPrize5(0);
        setTotalPersonPrize6(0);
      }
    },
    [connect]
  );

  useEffect(
    () => {
      if (connect) {
        if (parseInt(roundNumber) > 0) {
          getRoundHistory();
        }
      }
    },
    [connect, roundNumber]
  );

  const getRoundNumber = async () => {
    if (both) {
      if (parseInt(tuesdayTime) < parseInt(fridayTime)) {
        //tuesday
        getTuesdayRoundNumber();
      } else {
        //friday
        getFridayRoundNumber();
      }
    } else {
      if (tuesday) {
        getTuesdayRoundNumber();
      } else {
        getFridayRoundNumber();
      }
    }
  };

  const getRoundHistory = async () => {
    if (both) {
      if (parseInt(tuesdayTime) < parseInt(fridayTime)) {
        //tuesday
        getTuesdayHistory();
      } else {
        //friday
        getFridayHistory();
      }
    } else {
      if (tuesday) {
        getTuesdayHistory();
      } else {
        getFridayHistory();
      }
    }
  };

  const getFridayRoundNumber = async () => {
    const round = await lotteryContract.functions.roundNumber();
    setCurrentRoundNumber(round.toString());
    setRoundNumber(parseInt(round.toString()) - 1);
  };

  const getTuesdayRoundNumber = async () => {
    const round = await tuesdayContract.functions.roundNumber();
    setCurrentRoundNumber(round.toString());
    setRoundNumber(parseInt(round.toString()) - 1);
  };

  const getFridayHistory = async () => {
    const winningNumber = await lotteryContract.functions.historyOfWinnigNumbers(
      roundNumber
    );
    const prizeTotal = await lotteryContract.functions.historyOfPrizeTotalAmounts(
      roundNumber
    );
    const prizePerPerson = await lotteryContract.functions.historyOfPrizePerPersonAmounts(
      roundNumber
    );
    const winners = await lotteryContract.functions.historyOfLotteryPrizeWinners(
      roundNumber
    );

    // console.log('winningNumber', winningNumber);
    setWinningNumber1(winningNumber[0].toString());
    setWinningNumber2(winningNumber[1].toString());
    setWinningNumber3(winningNumber[2].toString());
    setWinningNumber4(winningNumber[3].toString());
    setWinningNumber5(winningNumber[4].toString());
    setWinningNumber6(winningNumber[5].toString());
    setWinningNumber7(winningNumber[6].toString());

    // console.log('prizeTotal', prizeTotal);
    setTotalPoolPrize1(ethers.utils.formatEther(prizeTotal[3].toString()));
    setTotalPoolPrize2(ethers.utils.formatEther(prizeTotal[4].toString()));
    setTotalPoolPrize3(ethers.utils.formatEther(prizeTotal[5].toString()));
    setTotalPoolPrize4(ethers.utils.formatEther(prizeTotal[6].toString()));
    setTotalPoolPrize5(ethers.utils.formatEther(prizeTotal[7].toString()));
    setTotalPoolPrize6(ethers.utils.formatEther(prizeTotal[8].toString()));
    setMaintenanceAmount(ethers.utils.formatEther(prizeTotal[9].toString()));
    setTotalPlayer(prizeTotal[2].toString());
    setPoolPrize(ethers.utils.formatEther(prizeTotal[0].toString()));
    setDrawnTime(prizeTotal[1].toString());

    // console.log('prizePerPerson', prizePerPerson);
    setPerPersonPrize1(
      ethers.utils.formatEther(prizePerPerson[0].toString())
    );
    setPerPersonPrize2(
      ethers.utils.formatEther(prizePerPerson[1].toString())
    );
    setPerPersonPrize3(
      ethers.utils.formatEther(prizePerPerson[2].toString())
    );
    setPerPersonPrize4(
      ethers.utils.formatEther(prizePerPerson[3].toString())
    );
    setPerPersonPrize5(
      ethers.utils.formatEther(prizePerPerson[4].toString())
    );
    setPerPersonPrize6(
      ethers.utils.formatEther(prizePerPerson[5].toString())
    );

    // console.log('winners', winners);
    setTotalPersonPrize1(winners[0].toString());
    setTotalPersonPrize2(winners[1].toString());
    setTotalPersonPrize3(winners[2].toString());
    setTotalPersonPrize4(winners[3].toString());
    setTotalPersonPrize5(winners[4].toString());
    setTotalPersonPrize6(winners[5].toString());
  };

  const getTuesdayHistory = async () => {
    const winningNumber = await tuesdayContract.functions.historyOfWinnigNumbers(
      roundNumber
    );
    const prizeTotal = await tuesdayContract.functions.historyOfPrizeTotalAmounts(
      roundNumber
    );
    const prizePerPerson = await tuesdayContract.functions.historyOfPrizePerPersonAmounts(
      roundNumber
    );
    const winners = await tuesdayContract.functions.historyOfLotteryPrizeWinners(
      roundNumber
    );

    // console.log('winningNumber', winningNumber);
    setWinningNumber1(winningNumber[0].toString());
    setWinningNumber2(winningNumber[1].toString());
    setWinningNumber3(winningNumber[2].toString());
    setWinningNumber4(winningNumber[3].toString());
    setWinningNumber5(winningNumber[4].toString());
    setWinningNumber6(winningNumber[5].toString());
    setWinningNumber7(winningNumber[6].toString());

    // console.log('prizeTotal', prizeTotal);
    setTotalPoolPrize1(ethers.utils.formatEther(prizeTotal[3].toString()));
    setTotalPoolPrize2(ethers.utils.formatEther(prizeTotal[4].toString()));
    setTotalPoolPrize3(ethers.utils.formatEther(prizeTotal[5].toString()));
    setTotalPoolPrize4(ethers.utils.formatEther(prizeTotal[6].toString()));
    setTotalPoolPrize5(ethers.utils.formatEther(prizeTotal[7].toString()));
    setTotalPoolPrize6(ethers.utils.formatEther(prizeTotal[8].toString()));
    setMaintenanceAmount(ethers.utils.formatEther(prizeTotal[9].toString()));
    setTotalPlayer(prizeTotal[2].toString());
    setPoolPrize(ethers.utils.formatEther(prizeTotal[0].toString()));
    setDrawnTime(prizeTotal[1].toString());

    // console.log('prizePerPerson', prizePerPerson);
    setPerPersonPrize1(
      ethers.utils.formatEther(prizePerPerson[0].toString())
    );
    setPerPersonPrize2(
      ethers.utils.formatEther(prizePerPerson[1].toString())
    );
    setPerPersonPrize3(
      ethers.utils.formatEther(prizePerPerson[2].toString())
    );
    setPerPersonPrize4(
      ethers.utils.formatEther(prizePerPerson[3].toString())
    );
    setPerPersonPrize5(
      ethers.utils.formatEther(prizePerPerson[4].toString())
    );
    setPerPersonPrize6(
      ethers.utils.formatEther(prizePerPerson[5].toString())
    );

    // console.log('winners', winners);
    setTotalPersonPrize1(winners[0].toString());
    setTotalPersonPrize2(winners[1].toString());
    setTotalPersonPrize3(winners[2].toString());
    setTotalPersonPrize4(winners[3].toString());
    setTotalPersonPrize5(winners[4].toString());
    setTotalPersonPrize6(winners[5].toString());
  };
  // useEffect (() => {
  //   window.addEventListener ('scroll', onScroll);
  //   return () => {
  //     window.removeEventListener ('scroll', onScroll);
  //   };
  // }, []);
  return (
    <div>
      <div className="w-full min-h-screen flex flex-col justify-between">
        <div className="flex justify-evenly flex-col md:flex-row mt-10">
          <div className="space-y-4 text-white">
            <h1 className="text-3xl sm:text-4xl text-center text-lyellow">
              Finished Rounds
            </h1>
            {both
              ? <>
                {(parseInt(tuesdayTime) < parseInt(fridayTime)) ?
                  <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-5xl">
                    Tuesday Lottery{' '}
                  </h1>
                  :
                  <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-5xl">
                    Friday Lottery
                  </h1>
                }
              </>
              : tuesday
                ? <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-5xl">
                  Tuesday Lottery{' '}
                </h1>
                : <h1 className="text-lyellow font-sans font-bold text-center mt-6 text-5xl">
                  Friday Lottery
                </h1>}

            <div className="flex justify-center items-center w-full">
              <button
                className={toggle ? styles.active : styles.inactive}
                
                onClick={() => setToggle(true)}
                style={{ marginRight: '1rem' }}
              >
                All History
              </button>
              <button
                className={!toggle ? styles.active : styles.inactive}
            
                onClick={() => setToggle(false)}

              >
                Your History
              </button>
            </div>

            {toggle ? (
              <YourHistory
                roundNumber={roundNumber}
                setRoundNumber={setRoundNumber}
                currentRoundNumber={currentRoundNumber}
                drawnTime={drawnTime}
                winningNumber1={winningNumber1}
                winningNumber2={winningNumber2}
                winningNumber3={winningNumber3}
                winningNumber4={winningNumber4}
                winningNumber5={winningNumber5}
                winningNumber6={winningNumber6}
                winningNumber7={winningNumber7}
                poolPrize={poolPrize}
                totalPoolPrize6={totalPoolPrize6}
                perPersonPrize6={perPersonPrize6}
                totalPlayer={totalPlayer}
                totalPersonPrize6={totalPersonPrize6}
                totalPoolPrize5={totalPoolPrize5}
                perPersonPrize5={perPersonPrize5}
                totalPersonPrize5={totalPersonPrize5}
                totalPersonPrize4={totalPersonPrize4}
                totalPoolPrize4={totalPoolPrize4}
                perPersonPrize4={perPersonPrize4}
                totalPersonPrize3={totalPersonPrize3}
                totalPoolPrize3={totalPoolPrize3}
                perPersonPrize3={perPersonPrize3}
                totalPoolPrize2={totalPoolPrize2}
                perPersonPrize2={perPersonPrize2}
                totalPersonPrize2={totalPersonPrize2}
                totalPoolPrize1={totalPoolPrize1}
                perPersonPrize1={perPersonPrize1}
                totalPersonPrize1={totalPersonPrize1}
                maintenanceAmount={maintenanceAmount}
              />
            ) : (
              <div>
                {both ?
                  <>
                    {(parseInt(tuesdayTime) < parseInt(fridayTime)) ?
                      <FRTable lotteryContract={tuesdayContract} />
                      :
                      <FRTable lotteryContract={lotteryContract} />
                    }
                  </>
                  :
                  <>
                    {tuesday ?
                      <FRTable lotteryContract={tuesdayContract} />
                      :
                      <FRTable lotteryContract={lotteryContract} />
                    }
                  </>
                }
              </div>
            )}
          </div>
        </div>
      </div>
      <MarginBottom />
    </div>
  );
};

export default FRHistory;
